import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { useActivityPublicContext } from '../../ActivityPublicContext';

import styles from './styles.scss';

export function photoSrc(photo) {
  return photo.urls && photo.urls[Object.keys(photo.urls)[0]];
}

export default function Photos({ photos }) {
  const { openSignUpModal, track } = useActivityPublicContext();

  if (photos.length === 0) {
    return null;
  }

  const trackPhotoClick = () => track({ element: 'photo', action: 'click' });

  const maxPhotos = 4;
  const displayPhotos = photos.slice(0, maxPhotos);
  const overflowCount = photos.length - maxPhotos + 1;

  const PhotoButton = ({ children, ...props }) => {
    return (
      <button
        onClick={() => {
          trackPhotoClick();
          openSignUpModal('generic');
        }}
        data-cy="photo"
        {...props}
      >
        {children}
      </button>
    );
  };

  PhotoButton.propTypes = { children: PropTypes.node.isRequired };

  return (
    <div className={styles.container}>
      <h3>
        {I18n.t('strava.activities.show_public.photos_v2', {
          count: photos.length
        })}
      </h3>
      <ul className={styles.photosList}>
        {displayPhotos.map((photo) => (
          <li key={photo.unique_id}>
            <PhotoButton className={styles.photoWrapper}>
              <img src={photoSrc(photo)} alt={photo.caption} />
            </PhotoButton>
          </li>
        ))}

        {overflowCount > 1 && (
          <li className={styles.overflow}>
            <PhotoButton className={styles.overflowCount}>
              +{overflowCount}
            </PhotoButton>
          </li>
        )}
      </ul>
    </div>
  );
}

Photos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired
};
